const SCHEME_PATTERN = /^[a-z][a-z\d+.-]*:/i;
const ALLOWED_PROTOCOLS: ReadonlySet<string> = new Set(['http:', 'https:']);

/**
 * The `href` to open for a link a person typed or an outside sender supplied (e.g. an invitation's
 * meeting link), or `null` when it must stay plain text.
 *
 * Only http(s) opens: any other scheme (`javascript:`, `data:`, `file:`, app handlers) is refused. A
 * value without a scheme (`zoom.us/j/123`) opens over https when it starts with a dotted host name.
 */
export function toExternalHref(value: string | null | undefined): string | null {
  const text = value?.trim();
  if (!text || /\s/.test(text)) {
    return null;
  }

  const hasScheme = SCHEME_PATTERN.test(text);
  let url: URL;
  try {
    url = new URL(hasScheme ? text : `https://${text}`);
  } catch {
    return null;
  }

  if (!ALLOWED_PROTOCOLS.has(url.protocol)) {
    return null;
  }
  if (!hasScheme && !url.hostname.includes('.')) {
    return null;
  }
  return url.href;
}
